import { Locale } from '../../modules/locale'
import { LvcPrimarySliderItem } from '../../modules/sliderUtils'
import { EventStatus } from './lvc-event-status'

export const renderTicketButton = (data: LvcPrimarySliderItem, componentLocation: string) => {
  if (data.status === EventStatus.Cancelled) {
    return ''
  }
  switch (data.schema) {
    case 'places':
      return data.location?.[Locale.language]
        ? `<lvc-google-maps slot="ticket" place-name="${data.name?.fr}" data-component-location="${componentLocation}" location-string="${data.location?.[Locale.language]}"></lvc-google-maps>`
        : ''
    default:
      if (!data.isAccessibleForFree) {
        if (data.url?.[Locale.language] || data.url?.fr) {
          return `<lvc-event-ticket slot="ticket" event-data="${encodeURIComponent(JSON.stringify(data))}" event-id="${data.id}" data-component-location="${componentLocation}" is-free="${data.isAccessibleForFree}" href="${data.url?.[Locale.language] || data.url?.fr || ''}"></lvc-event-ticket>`
        } else if (data.location?.[Locale.language]) {
          return `<lvc-google-maps slot="ticket" event-name="${data.name?.[Locale.language]}" place-name="${data.location.fr?.split(',')[0]}" data-component-location="${componentLocation}" location-string="${data.location?.[Locale.language]}"></lvc-google-maps>`
        } else {
          return ''
        }
      } else if (data.isAccessibleForFree) {
        if (data.url?.[Locale.language] || data.url?.fr) {
          return `<lvc-event-ticket slot="ticket" event-data="${encodeURIComponent(JSON.stringify(data))}" event-id="${data.id}" data-component-location="${componentLocation}" is-free="${data.isAccessibleForFree}" href="${data.url?.[Locale.language] || data.url?.fr || ''}"></lvc-event-ticket>`
        } else if (data.urlConstruct?.[Locale.language]) {
          return `<lvc-event-ticket slot="ticket" event-data="${encodeURIComponent(JSON.stringify(data))}" event-id="${data.id}" data-component-location="${componentLocation}" is-free="${data.isAccessibleForFree}" href="${data.urlConstruct?.[Locale.language]}"></lvc-event-ticket>`
        } else {
          return ''
        }
      }
  }
}

export const renderDateElement = (
  data: LvcPrimarySliderItem,
  status?: string,
  previousStartDate?: string
) => {
  switch (data.schema) {
    case 'places':
    case 'contributors':
      return data.publishedEventsCount
        ? `<lvc-event-count slot="date" count="${data.publishedEventsCount}"></lvc-event-count>`
        : ''
    case 'exhibitionEvents':
      if (!data.exhibitionType) return ``
      if (data.exhibitionType === 'Permanent') {
        return `<lvc-event-date slot="date" status="${status}" text="${Locale.language === 'en' ? 'Permanent' : 'Permanent'}"></lvc-event-date>`
      }
    default:
      return data.formattedDateTime
        ? `<lvc-event-date slot="date" status="${status}" previous-start-date="${previousStartDate}" text="${data.formattedDateTime}"></lvc-event-date>`
        : ''
  }
}
